/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hero_Stat_Rebook_NoteInputs */

const en_hero_stat_rebook_note = /** @type {(inputs: Hero_Stat_Rebook_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`after month one`)
};

const pl_hero_stat_rebook_note = /** @type {(inputs: Hero_Stat_Rebook_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`po pierwszym miesiącu`)
};

/**
* | output |
* | --- |
* | "after month one" |
*
* @param {Hero_Stat_Rebook_NoteInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const hero_stat_rebook_note = /** @type {((inputs?: Hero_Stat_Rebook_NoteInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hero_Stat_Rebook_NoteInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_hero_stat_rebook_note(inputs)
	return en_hero_stat_rebook_note(inputs)
});